module.exports = __webpack_public_path__ + "static/media/certyfikat-22.79c3b45c.png";